module.exports = __webpack_public_path__ + "static/media/notification.bc574a30.mp3";